import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'tdesign-react';
import DescriptionItem from '../DescriptionItem';

export default function FormInfoBlock({ items = [] }) {
  return (
    <Root>
      <Row gutter={[0, 20]}>
        {items.map((item, index) => (
          <Col span={12} key={index}>
            {React.isValidElement(item) ? (
              item
            ) : (
              <DescriptionItem label={item.label} value={item.value} />
            )}
          </Col>
        ))}
      </Row>
    </Root>
  );
}

const Root = styled.div`
  padding: 20px;
  margin: 20px;
  box-sizing: border-box;
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  .description-label,
  .description-value {
    font-size: 14px;
    line-height: 22px;
    color: #202b40;
  }
`;
